import { TextProps } from '@rneui/base'
import { Text } from '@rneui/themed'

export const NonSelectableText = ({ children, ...props }: TextProps) => (
  <Text selectable={false} {...props}>
    {children}
  </Text>
)
